<nav id="sidebar" class="sidebar-wrapper sidebar-dark bg-light-blue font-montserrat ">
    <div class="sidebar-content">
        <div class="logo sidebar-brand pt-8 pl-[55px]">
            <a routerLink="/"><img src="assets/images/sidebar-logo.png" height="12" alt="" class="max-w-[140px]"></a>
        </div>

        <ul class=" pt-8" simplebar style="height: calc(100% - 70px);">
            <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
                routerLinkActive="active ms-0" [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="constants.ADMIN_DASHBOARD" (click)="toggleSideBar()" class="flex items-center text-sm">
                    <div class="min-w-8 min-h-8 flex items-center justify-center">
                        <img src="assets/images/app/sidebar/dashboard-sidebar-unselected.svg" alt="Tournaments"
                            class="w-[15px] h-[15px] me-2" *ngIf="!isActive(constants.ADMIN_DASHBOARD)">
                        <img src="assets/images/app/sidebar/dashboard-sidebar-selected.svg" alt="Tournaments"
                            class="w-[15px] h-[15px] me-2" *ngIf="isActive(constants.ADMIN_DASHBOARD)">
                    </div>
                    Dashboard
                </a>
            </li>

            <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
                routerLinkActive="active ms-0">
                <a [routerLink]="constants.ADMIN_CLUBS" (click)="toggleSideBar()" class="flex items-center text-sm">
                    <div class="min-w-8 min-h-8 flex items-center justify-center">
                        <img src="assets/images/app/sidebar/tournament-sidebar-unselected.svg" alt="Tournaments"
                            class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.ADMIN_CLUBS)">
                        <img src="assets/images/app/sidebar/tournament-sidebar-selected.svg" alt="Tournaments"
                            class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.ADMIN_CLUBS)">
                    </div>
                    Clubs
                </a>
            </li>

            <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
                routerLinkActive="active ms-0">
                <a [routerLink]="constants.ADMIN_LEAGUES" (click)="toggleSideBar()" class="flex items-center text-sm">
                    <div class="min-w-8 min-h-8 flex items-center justify-center">
                        <img src="assets/images/app/sidebar/tournament-sidebar-unselected.svg" alt="Tournaments"
                            class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.ADMIN_LEAGUES)">
                        <img src="assets/images/app/sidebar/tournament-sidebar-selected.svg" alt="Tournaments"
                            class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.ADMIN_LEAGUES)">
                    </div>
                    Leagues
                </a>
            </li>
            <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
                routerLinkActive="active ms-0">
                <a [routerLink]="constants.ADMIN_GROUNDS" (click)="toggleSideBar()" class="flex items-center text-sm">
                    <div class="min-w-8 min-h-8 flex items-center justify-center">
                        <img src="assets/images/app/sidebar/match-sidebar-unselected.svg" alt="Matches"
                            class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.ADMIN_GROUNDS)">
                        <img src="assets/images/app/sidebar/match-sidebar-selected.svg" alt="Matches"
                            class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.ADMIN_GROUNDS)">
                    </div>
                    Grounds
                </a>
            </li>
            <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
                routerLinkActive="active ms-0">
                <a [routerLink]="constants.ADMIN_FEATURE_FLAGS" (click)="toggleSideBar()" class="flex items-center text-sm">
                    <div class="min-w-8 min-h-8 flex items-center justify-center">
                        <img src="assets/images/app/sidebar/settings-sidebar-unselected.svg" alt="Feature Flags"
                            class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.ADMIN_FEATURE_FLAGS)">
                        <img src="assets/images/app/sidebar/settings-sidebar-selected.svg" alt="Feature Flags"
                            class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.ADMIN_FEATURE_FLAGS)">
                    </div>
                    Feature Flags
                </a>
            </li>
            <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
                routerLinkActive="active ms-0">
                <a [routerLink]="constants.ADMIN_MAINTENANCE" (click)="toggleSideBar()" class="flex items-center text-sm">
                    <div class="min-w-8 min-h-8 flex items-center justify-center">
                        <img src="assets/images/app/sidebar/maintenance-sidebar-unselected.svg" alt="Maintenance"
                            class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.ADMIN_MAINTENANCE)">
                        <img src="assets/images/app/sidebar/maintenance-sidebar-selected.svg" alt="Maintenance"
                            class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.ADMIN_MAINTENANCE)">
                    </div>
                    Maintenance
                </a>
            </li>
        </ul>
        <!-- sidebar-menu  -->
    </div>
</nav>